const HEADERS = ['', 'One-Email', 'Resend', 'Postmark', 'SendGrid']

const ROWS = [
  ['Free tier', '10K/mo (1K/day)', '3K/mo (100/day)', '100/mo', '3K/mo (100/day)'],
  ['75K emails/mo', '$18', '$43+', '$75+', '$35+'],
  ['300K emails/mo', '$45', '$200+', '$400+', '$90'],
  ['Dedicated IP', '$29 + auto warming', 'Not available', '$50, manual warm', '$90, manual warm'],
  ['Marketing emails', 'From $15/mo, isolated IPs', '$250+ for 50K', 'Not offered', 'Separate product'],
  ['Overage rate', '$0.30/1K', '$0.90/1K', '$1.30/1K', '$0.50/1K'],
  ['ISP analytics', 'Gmail/Outlook/Yahoo breakdown', 'No', 'No', 'Enterprise only'],
  ['Overage policy', '10% buffer + 3 free', 'Hard limit', 'Auto-charge', 'Auto-charge'],
]

const ONE_EMAIL_HIGHLIGHTS = new Set([
  '10K/mo (1K/day)', '$18', '$45', '$29 + auto warming',
  'From $15/mo, isolated IPs', '$0.30/1K',
  'Gmail/Outlook/Yahoo breakdown', '10% buffer + 3 free',
])

const DIM_VALUES = new Set([
  'Not available', 'Not offered', 'No', 'Enterprise only',
])

export function ComparisonTable() {
  return (
    <section className="section-pad" style={{ maxWidth: 1000, margin: '0 auto', paddingTop: 80, paddingBottom: 80 }}>
      <div style={{ textAlign: 'center', marginBottom: 48 }}>
        <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 800, letterSpacing: '-0.03em', marginBottom: 12 }}>
          The{' '}
          <span
            style={{
              fontFamily: "var(--oe-font-serif)", fontStyle: 'italic',
              textDecoration: 'line-through', color: '#999',
            }}
          >
            unfair
          </span>{' '}
          comparison
        </h2>
        <p style={{ color: '#777', fontSize: 16 }}>
          Real pricing, real features. No &ldquo;contact sales&rdquo;.
        </p>
      </div>

      <div
        style={{
          overflowX: 'auto',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <div
          style={{
            background: '#fff', borderRadius: 20, overflow: 'hidden',
            boxShadow: '0 8px 40px rgba(0,0,0,0.06)', border: '1px solid #EDE9E4',
            minWidth: 700,
          }}
        >
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {HEADERS.map((h, i) => (
                  <th
                    key={i}
                    scope="col"
                    style={{
                      padding: '20px 22px',
                      textAlign: i === 0 ? 'left' : 'center',
                      fontWeight: 700,
                      fontSize: i === 1 ? 16 : 14,
                      color: i === 1 ? '#FF6B00' : '#777',
                      borderBottom: '1px solid #f0ece8',
                      background: i === 1 ? '#FFF8F2' : 'transparent',
                    }}
                  >
                    {h}
                    {i === 1 && (
                      <span
                        style={{
                          display: 'inline-block', fontSize: 10, fontWeight: 800,
                          background: '#FF6B00', color: '#fff', padding: '2px 8px',
                          borderRadius: 100, marginTop: 4, marginLeft: 6,
                        }}
                      >
                        YOU ARE HERE
                      </span>
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row, i) => (
                <tr key={i}>
                  {row.map((cell, j) => {
                    const isOneEmail = j === 1
                    const isHighlighted = isOneEmail && ONE_EMAIL_HIGHLIGHTS.has(cell)
                    const isDim = !isOneEmail && DIM_VALUES.has(cell)
                    const isMono = cell.startsWith('$') || cell.includes('/mo') || cell.includes('/1K') || cell.includes('/day')

                    const cellStyle = {
                      padding: '16px 22px',
                      textAlign: j === 0 ? ('left' as const) : ('center' as const),
                      fontSize: 14,
                      fontWeight: j === 0 ? 600 : isHighlighted ? 700 : 400,
                      color: j === 0
                        ? '#1a1216'
                        : isHighlighted
                          ? '#FF6B00'
                          : isDim
                            ? '#bbb'
                            : '#777',
                      borderBottom: i < ROWS.length - 1 ? '1px solid #f5f2ef' : 'none',
                      background: isOneEmail ? '#FFF8F2' : 'transparent',
                      fontFamily: isMono ? "var(--oe-font-mono)" : 'inherit',
                      lineHeight: 1.5,
                    }
                    if (j === 0) {
                      return <th key={j} scope="row" style={cellStyle}>{cell}</th>
                    }
                    return <td key={j} style={cellStyle}>{cell}</td>
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}
